<script>
  export default {
    name: "SidebarEmptyState",
    props: {
      message: { type: String, default: "No hay datos disponibles" },
    },
  };
</script>

<template>
  <div class="sidebarEmptyState">
    <p class="sidebarEmptyState__text">{{ message }}</p>
  </div>
</template>

<style lang="scss">
  .sidebarEmptyState {
    @include Flex(column, center, center);
    width: 100%;
    height: 100%;
    font-size: 16px;

    &__text {
      font-weight: bold;
      overflow-wrap: anywhere;
    }
  }
</style>
